export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7559.36a7cf8a.jpg";